export default {
  barTitle: 'Cookies',
  barDescription:
    'Utilizamos cookies propias y de terceros para poder mostrarle una página web y comprender cómo la utiliza, con el fin de mejorar los servicios que ofrecemos. Si continúa navegando, consideramos que acepta su uso.',
  acceptAll: 'Aceptar todo',
  declineAll: 'Borrar todo',
  manageCookies: 'Administrar cookies',
  unsaved: 'Tienes configuraciones no guardadas',
  close: 'Cerrar',
  save: 'Guardar',
  necessary: 'Cookies obligatorias',
  optional: 'Cookies opcionales',
  functional: 'Cookies funcionales',
  blockedIframe: 'Para ver esto, por favor habilita las cookies funcionales.',
  here: 'aquí'
}
